import { UIText2 } from '@cian/ui-kit';

import { type FC } from 'react';

import styles from './QuickLinksMoreItemsButton.css';

export type QuickLinksMoreItemsButtonProps = {
  title: string;
  onClick(): void;
  dataTestId: string;
  icon: JSX.Element;
};

export const QuickLinksMoreItemsButton: FC<QuickLinksMoreItemsButtonProps> = props => {
  const { onClick, title, dataTestId, icon } = props;

  return (
    <button className={styles['container']} data-testid={dataTestId} role="button" onClick={onClick}>
      <UIText2 color="primary_100">{title}</UIText2>
      {icon}
    </button>
  );
};
